import Contract from "./Contract";

const Index = () => {

    
    return (
        <>
            <Contract title={"Remaining Purchase Contracts"} settlementType={"3"}/>
        </>
    );
};

export default Index;
